import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { SheetSlotComponentBase } from 'src/app/services/sheets-renderer.service';
import { RemovePressureBandageAction } from 'src/app/types/sheet-action-aggregate-graph.types';
import { TickValueComponent } from '../../tick-value/tick-value.component';

@Component({
    selector: 'app-remove-pressure-bandage-slot',
    templateUrl: './remove-pressure-bandage-slot.component.html',
    styleUrl: './remove-pressure-bandage-slot.component.scss',
    imports: [TickValueComponent],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class RemovePressureBandageSlotComponent implements SheetSlotComponentBase {

	@Input() action!: RemovePressureBandageAction;
	value = null;

	constructor() {
	}
}